import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container flex-grow pt-5 mx-auto" }

import Navigation from '@/components/Nav/Navigation.vue';
import Footer from '@/components/Nav/Footer.vue';
import Status from '@/components/System/Status.vue';
import NotLoggedIn from '@/components/System/NotLoggedIn.vue';
import { useUserStore } from '@/store/users';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useUserStore();
const loggedIn = computed(() => !!store.user);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Status),
    _createVNode(Navigation),
    (!_unref(loggedIn))
      ? (_openBlock(), _createBlock(NotLoggedIn, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(Footer, { class: "flex-shrink hidden lg:flex" })
  ], 64))
}
}

})